import { GQLFooterFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { HTMLAttributes } from 'react';

interface AcknowledgesProps extends HTMLAttributes<HTMLDivElement> {
	data: GQLFooterFragment;
}

export function Acknowledges({ data, ...props }: AcknowledgesProps) {
	return (
		<p {...props} className={cn('font-normal text-sm md:text-base', props.className)}>
			{data.acknowledgements}
		</p>
	);
}
